var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 102.4,
    y: 140.8,
    style: {
      fill: "#919CB0"
    },
    width: 307.2,
    height: 358.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.8,
    y: 64,
    style: {
      fill: "#BDC4D0"
    },
    width: 358.4,
    height: 76.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 166.4,
    y: 230.4,
    style: {
      fill: "#573A32"
    },
    width: 25.6,
    height: 204.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.2,
    y: 230.4,
    style: {
      fill: "#573A32"
    },
    width: 25.6,
    height: 204.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 230.4,
    style: {
      fill: "#573A32"
    },
    width: 25.6,
    height: 204.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M89.6,153.6v332.8c0,14.14,11.46,25.6,25.6,25.6h281.6c14.14,0,25.6-11.46,25.6-25.6V153.6 c14.14,0,25.6-11.46,25.6-25.6V76.8c0-14.14-11.46-25.6-25.6-25.6H320V25.6C320,11.46,308.54,0,294.4,0h-76.8 C203.46,0,192,11.46,192,25.6v25.6H89.6C75.46,51.2,64,62.66,64,76.8V128C64,142.14,75.46,153.6,89.6,153.6z M396.8,486.4H115.2 V153.6h281.6V486.4z M217.6,25.6h76.8v25.6h-76.8V25.6z M89.6,76.8h332.8V128H89.6V76.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.fe154da20fc56619743a3dca3ff2b758.svg";
export { ForwardRef as ReactComponent };